import { useCallback } from 'react'

interface useMapsURLProps {
  origin?: google.maps.LatLngLiteral
  destination: google.maps.LatLngLiteral
}

const useMapsURL = ({ origin, destination }: useMapsURLProps) => {
  const openMaps = useCallback(() => {
    const googleMapsUrl = origin
      ? `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}`
      : `https://www.google.com/maps/dir/?api=1&destination=${destination.lat},${destination.lng}`
    const appleMapsUrl = origin
      ? `http://maps.apple.com/?saddr=${origin.lat},${origin.lng}&daddr=${destination.lat},${destination.lng}`
      : `http://maps.apple.com/?daddr=${destination.lat},${destination.lng}`

    const userAgent = navigator.userAgent || window.opera

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.open(appleMapsUrl, '_blank')
    } else {
      window.open(googleMapsUrl, '_blank')
    }
  }, [destination.lat, destination.lng, origin])

  return { openMaps }
}

export default useMapsURL
